import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ModalMessageComponent } from 'src/app/shared/components/modals/modal-message/modal-message.component';
import { BreadcrumbsService } from 'src/app/shared/services/breadcrumbs.service';
import { EnvioSimpleDocumentoApiService } from '../../services/envio-simple-documento-api.service';
import { EnvioSimpleFlowService } from '../../services/envio-simple-flow.service';

@Component({
  selector: 'app-envio-simple-documentos-page',
  templateUrl: './envio-simple-documentos-page.component.html',
  styleUrls: ['./envio-simple-documentos-page.component.css']
})
export class EnvioSimpleDocumentosPageComponent implements OnInit, OnDestroy {
  tieneDocumentos = false;
  private readonly destroy$ = new Subject<void>();

  constructor(
    public envioSimpleFlowService: EnvioSimpleFlowService,
    private envioSimpleDocumentoApiService: EnvioSimpleDocumentoApiService,
    private breadcrumbsService: BreadcrumbsService,
    private router: Router,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    if (history.state?.reiniciarFlujo) {
      this.envioSimpleFlowService.inicializar();
      this.envioSimpleDocumentoApiService.limpiarCacheCatalogo();
    }
    this.envioSimpleFlowService.tipoEnvio = 'ENVIO_SIMPLE';
    this.envioSimpleFlowService.establecerPaso(0);
    this.breadcrumbsService.addBreadcrumbs('Envío simple');

    this.envioSimpleFlowService.hayDocumentos$
      .pipe(takeUntil(this.destroy$))
      .subscribe(hayDocumentos => {
        this.tieneDocumentos = hayDocumentos;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  atras(): void {
    history.back();
  }

  onContinuarClick(): void {
    if (!this.envioSimpleFlowService.tieneDocumentos) {
      this.avisarDocumentoRequerido();
    }
  }

  siguiente(): void {
    if (!this.envioSimpleFlowService.tieneDocumentos) {
      return;
    }
    this.envioSimpleFlowService.prepararPasoFirmantes();
    this.envioSimpleFlowService.establecerPaso(1);
    this.router.navigate(['/panel/envio-simple/firmantes']);
  }

  private avisarDocumentoRequerido(): void {
    this.dialog.open(ModalMessageComponent, {
      data: {
        mensaje: 'Debe añadir como mínimo un documento para continuar con la configuración del envío simple.',
        alert: true
      }
    });
  }
}
